
import Vue from 'vue';
import { ImageModel } from '@descomplica/dex-models';
import ImageContent from '../contents/ImageContent.vue';

export default Vue.extend({
  components: {
    ImageContent,
  },
  props: {
    content: {
      type: ImageModel,
      required: true,
    },
  },
});
